import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

export const AUTH_TOKEN = 'token';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token: string = localStorage.getItem(AUTH_TOKEN);
        if (!!token) {
            request = request.clone({
                headers: request.headers.set('Authorization', `Token ${token}`)
            });
        }

        return next.handle(request);
    }
}
